import { Component } from '@angular/core';

@Component({
  selector: 'edge-vr-content',
  templateUrl: './vr-content.component.html',
  styleUrls: ['./vr-content.component.scss']
})
export class VRContentComponent {
  features = [
    {
      image: 'vr/See_Plays_VR.PNG',
      title: 'See Your Plays in Virtual Reality on the Meta Quest',
      description: `
      Put your players on the virtual field! Select a player to view
      the play from their eyes, or pick a spot on the field to watch it unfold.`
    },
    {
      image: 'vr/Meta_Quest_2.PNG',
      title: 'Use Existing Edge Plays',
      description: `
      All of the playbooks, drills, plays, and formations you've already created
      in GoArmy Edge are available in GoArmy Edge VR out of the box. New content
      works as well!`
    },
    {
      image: 'vr/Drills.PNG',
      title: 'Run Through Realistic Drills',
      description: `
      Set up drills in GoArmy Edge to teach and quiz formations, plays, alignments - anything.
      Your players will immediately have access in GoArmy Edge VR.`
    }
  ];
}
